import {
  API_ERROR,
  CLOSE_NOTIFICATION,
  CLEAR_NOTIFICATIONS,
  QUEUE_NOTIFICATION,
  LOADING,
  LOADING_DONE,
  SET_NAVBAR,
  UPDATE_CUSTOM_VIEWS,
  HIDE_TOPBAR,
} from 'actions/actionTypes';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const defaultState = {
  loading: false,
  notifications: [],
  alert: {},
  errors: [],
  showRouteModal: true,
  navbarDesktopOpen: true,
  customViews: {
    timetable: {
      x: 0,
      y: 40,
      width: 600,
      height: '90%'
    },
    map: {
      x: 600,
      y: 0,
      width: 800,
      height: '90%'
    },
    order: {
      x: 600,
      y: 800,
      width: 800,
      height: 200
    },
    devices: {
      x: 600,
      y: 600,
      width: 800,
      height: '15%'
    }
  }
};

export const selectCustomViews = state => state.ui.customViews;

export const reducer = (state = defaultState, action) => {
  switch (action.type) {
    // Globally catch API_ERRORs, same as queuing a new notification with type "error"
    case API_ERROR:
      return {
        ...state,
        errors: [
          ...state.errors,
          {
            id: Date.now(),
            type: 'error',
            message: action.payload.message
          }
        ]
      };
    case QUEUE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.concat([action.payload])
      };
    case CLOSE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          notification => notification.message !== action.payload
        )
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: []
      };
    case SET_NAVBAR:
      return {
        ...state,
        navbarDesktopOpen: action.payload
      };
    case HIDE_TOPBAR:
      return {
        ...state,
        topbarHidden: action.payload
      };
    case LOADING:
      return {
        ...state,
        loading: true
      };
    case LOADING_DONE:
      return {
        ...state,
        loading: false
      };
    case UPDATE_CUSTOM_VIEWS:
      return {
        ...state,
        customViews: {
          ...state.customViews,
          [action.payload.id]: action.payload.bounds
        }
      };

    default:
      return state;
  }
};

const persistConfig = {
  key: 'ui',
  storage,
  whitelist: ['customViews']
};
export default persistReducer(persistConfig, reducer);
